module.exports = __webpack_public_path__ + "img/jg2.7dad13e8.png";